import { render, staticRenderFns } from "./ListAccessory.vue?vue&type=template&id=2e07c8da&scoped=true&"
import script from "./ListAccessory.vue?vue&type=script&lang=js&"
export * from "./ListAccessory.vue?vue&type=script&lang=js&"
import style0 from "./ListAccessory.vue?vue&type=style&index=0&id=2e07c8da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e07c8da",
  null
  
)

export default component.exports